export const absoluteUrl = function (path: string, queryParams?: Record<string, string>) {
    const { protocol, host } = useRequestURL();

    const urlQueryParams = queryParams
        ? (new URLSearchParams(queryParams)).toString()
        : null;

    return `${protocol}//${host}${path}${urlQueryParams ? `?${urlQueryParams}` : ''}`;
};
